import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { ProductsDataView, ProductsState } from "@insite/client-framework/Store/Data/Products/ProductsState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ProductsState & { products: ProductModel[] } = {
    isLoading: {},
    idByPath: {},
    byId: {},
    dataViews: {},
    products: [],
    attributeTypesByPath: {},
};

const reducer = {
    "Data/Products/BeginLoadAllProducts": (draft: Draft<ProductsState>, action: { parameter: object }) => {
        setDataViewLoading(draft, action.parameter);
    },
    "Data/Products/CompleteLoadAllProducts": (
        draft: Draft<ProductsState & { products: ProductModel[] }>,
        action: { parameter: object; collection: ProductCollectionModel },
    ) => {
        const { parameter, collection } = action;

        setDataViewLoaded(
            draft,
            parameter,
            collection,
            collection => collection.products!,
            (product: ProductModel) => {
                draft.idByPath[product.canonicalUrl] = product.id;
            },
            (dataView: ProductsDataView) => {
                dataView.attributeTypeFacets = collection.attributeTypeFacets;
                dataView.brandFacets = collection.brandFacets;
                dataView.categoryFacets = collection.categoryFacets;
                dataView.correctedQuery = collection.correctedQuery;
                dataView.didYouMeanSuggestions = collection.didYouMeanSuggestions;
                dataView.exactMatch = collection.exactMatch;
                dataView.notAllProductsAllowed = collection.notAllProductsAllowed;
                dataView.notAllProductsFound = collection.notAllProductsFound;
                dataView.originalQuery = collection.originalQuery;
                dataView.priceRange = collection.priceRange;
                dataView.productLineFacets = collection.productLineFacets;
                dataView.searchTermRedirectUrl = collection.searchTermRedirectUrl;
            },
        );
        draft.products = collection?.products ?? [];
    },
};

const allProductsReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).allProducts = allProductsReducer;

export type CustomState = {
    allProducts: ProductsState;
} & ApplicationState;

type Reducers = {
    allProducts: typeof allProductsReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;